import { render, staticRenderFns } from "./MedsChart.vue?vue&type=template&id=be2be938&"
import script from "./MedsChart.vue?vue&type=script&lang=js&"
export * from "./MedsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports